<script lang="ts">
import { defineComponent } from "vue";
import { getAvailableModes } from "@/shared/utils/outs";
import OutModeParams from "@/features/out/OutModeParams.vue";
import { injectOut } from "@/shared/utils/injection";
import OutLightActions from "@/features/out/OutLightActions.vue";
import OutQuantities from "@/features/pool/dashboard/OutQuantities.vue";

export default defineComponent({
  ...injectOut,
  components: { OutQuantities, OutLightActions, OutModeParams },
  data() {
    return {
      selectedMode: null,
    };
  },
  computed: {
    availableModes() {
      return getAvailableModes(this.out!.index, this.pool);
    },
  },
});
</script>

<template>
  <div>
    <div class="card p-3 flex flex-col gap-4 mb-2">
      <div
        v-for="mode in availableModes"
        :key="mode.name"
        :class="{
          'opacity-50 pointer-events-none':
            out.mode === mode.value &&
            mode.minRoleToChange > (pool.access ?? token.dac),
          hidden:
            out.mode !== mode.value &&
            mode.minRoleToChange > (pool.access ?? token.dac),
        }"
      >
        <out-mode-params :mode="mode" />
      </div>
      {{ selectedMode }}
    </div>

    <out-light-actions />

    <out-quantities :out="out" :pool="pool" v-if="out" />
  </div>
</template>
